module.exports = __webpack_public_path__ + "static/media/appointmentBlack.23fb35a8.svg";